import React, { useContext, useReducer, useMemo } from "react";
import { actions } from "../actions/drawer";
import { CONFIG } from "../config";

const initialState = {
    drawerWidth: 320,
    minDrawerWidth: 96,
    openDesktopWidth: 87,
    barHeight: 88,
    open: false,
    openDesktop: window.localStorage.getItem(CONFIG.menu.desktop) ? JSON.parse(window.localStorage.getItem(CONFIG.menu.desktop)) : true
};

const DrawerContext = React.createContext({
    state: null,
    dispatch: null,
});

function handleMenu(state, payload) {
    return {...state, open: payload};
}

function handleMenuDesktop(state, payload) {
    window.localStorage.setItem(CONFIG.menu.desktop, payload);
    return {...state, openDesktop: payload};
}

function reducer(state, action) {
    switch (action.type) {
        case actions.HANDLE_MENU:
            return handleMenu(state, action.payload);
        case actions.HANDLE_MENU_DESKTOP:
            return handleMenuDesktop(state, action.payload);
        default:
            return state;
    }
}

export const DrawerProvider = ({ children }) => {

    const [state, dispatch] = useReducer(reducer, initialState);

    const contextValue = useMemo(() => {
        return { state, dispatch };
    }, [state, dispatch]);

    return <DrawerContext.Provider value={contextValue}>
        {children}
    </DrawerContext.Provider>
}


export const useDrawerProvider = () => useContext(DrawerContext);